import React, { useRef, useState } from "react";

import Header from "./Header.js";
import Footer from "./Footer.js";
import gupsyLogo from "../assets/logo23.png";
import {
  FaBrain,
  FaRocket,
  FaLayerGroup,
  FaFlask,
  FaRobot,
  FaMicrochip,
  FaGlobe,
  FaLock,
  FaClock
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import "./Styles.css";

export default function Products() {

  const navigate = useNavigate();
  const [expandedCard, setExpandedCard] = useState(null);

  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);

  /* =========================================================
     FEATURED PRODUCTS
  ========================================================= */

  const featuredProducts = [

    {
      icon: (
        <img
          src={gupsyLogo}
          alt="Gupsy"
          className="product-logo"
        />
      ),
      title: "Gupsy AI",
      desc:
        "Gupsy: India’s First AI Companion App",
      route: "/products/gupsy",
      active: true,
    },

    
  ];

  /* =========================================================
     UPCOMING PRODUCTS
  ========================================================= */

  const upcomingProducts = [

    {
      icon: <FaRobot />,
      title: "Neoroast AI",
      desc:
        "An AI-powered platform that analyzes and “roasts” websites, Instagram profiles, and YouTube channels by evaluating branding, content quality, engagement, design, SEO, and overall online presence — delivering sharp, actionable feedback for creators, businesses, and brands.",
    },

    {
      icon: <FaMicrochip />,
      title: "NeoCV AI",
      desc:
        "An AI-driven resume optimization platform that compares resumes against job descriptions, generates ATS and alignment scores, identifies skill and experience gaps, and creates personalized learning paths to improve job-fit and interview chances.",
    },

    {
      icon: <FaGlobe />,
      title: "NeoMock AI",
      desc:
        "An AI-powered interview simulator that creates personalized mock interviews based on a user’s resume and job description, asks role-specific questions, evaluates responses, and delivers actionable feedback on technical skills, communication, confidence, and overall interview readiness.",
    },

    // {
    //   icon: <FaClock />,
    //   title: "Future Concepts",
    //   desc:
    //     "Experimental ideas currently under research and testing.",
    // },
  ];

  /* =========================================================
     OTHER PRODUCTS
  ========================================================= */

  const otherProducts = [

    {
      icon: <FaLayerGroup />,
      title: "Business AI",
      desc:
        "Smart AI solutions designed for modern enterprises.",
    },

    {
      icon: <FaLock />,
      title: "AI Security",
      desc:
        "Privacy-first AI infrastructure and secure systems.",
    },

    {
      icon: <FaRocket />,
      title: "Automation Tools",
      desc:
        "Workflow automation powered by intelligent systems.",
    },

    {
      icon: <FaFlask />,
      title: "Research Labs",
      desc:
        "Experimental AI projects and future innovations.",
    },
  ];

  return (

    <div
      style={{
        background: "#020617",
        minHeight: "100vh",
      }}
    >

      {/* HEADER */}
      <Header
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef
        }}
      />

      {/* PAGE */}
      <div className="products-page">

        {/* =========================================================
           HEADER
        ========================================================= */}

        <div className="products-header">

          <p className="products-tag">
            OUR PRODUCTS
          </p>

          <h1 className="products-title">
            Explore the Neomonks ecosystem
          </h1>

          <p className="products-subtitle">
            AI-powered products crafted to simplify life,
            accelerate innovation, and unlock new possibilities.
          </p>

        </div>

        {/* =========================================================
           FEATURED
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            Featured Products
          </h2>

          <div className="products-grid">

            {featuredProducts.map((item, index) => (

              <div
                key={index}
                className={`product-card ${
                  !item.active ? "disabled-card" : ""
                }`}
                onClick={() =>
                  item.active && navigate(item.route)
                }
              >

                {item.active && (
                  <div className="product-icon">
                    {item.icon}
                  </div>
                )}

                <h3>{item.title}</h3>

                {item.desc && (
                  <p>{item.desc}</p>
                )}

              </div>

            ))}

          </div>

        </div>

        {/* =========================================================
           UPCOMING
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            Upcoming Products
          </h2>

          <div className="products-grid upcoming-grid">

  {upcomingProducts.map((item, index) => {

    const isExpanded =
      expandedCard === index;

    return (

      <div
        key={index}
        className={`product-card upcoming-card ${
          isExpanded ? "active-card" : ""
        }`}
      >

        <div className="product-icon">
          {item.icon}
        </div>

        <h3>{item.title}</h3>

        <p
          className={
            isExpanded
              ? "expanded-text"
              : "clamp-text"
          }
        >
          {item.desc}
        </p>

        <button
          className="read-more-btn"
          onClick={() =>
            setExpandedCard(
              isExpanded ? null : index
            )
          }
        >
          {isExpanded
            ? "Read Less <<"
            : "Read More >>"}
        </button>

      </div>

    );
  })}

</div>

        </div>

        {/* =========================================================
           OTHER PRODUCTS
        ========================================================= */}

        <div className="products-section">

          <h2 className="section-title">
            Other Solutions
          </h2>

          <div className="products-grid">

            {otherProducts.map((item, index) => (

              <div
                key={index}
                className="product-card"
              >

                <div className="product-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

              </div>

            ))}

          </div>

        </div>

      </div>

      {/* FOOTER */}
      <Footer
        sectionsRef={{
          about: aboutRef,
          getInTouch: getInTouchRef
        }}
      />

    </div>
  );
}